export interface TrainModule {
  name: string
  level: number
  id?: string
  desc?: string
  videos?: TrainAnnexFile[]
  docs?: TrainAnnexFile[]
  subs?: TrainModule[]
  nav?: boolean
}

export interface TrainAnnexFile {
  name: string
  type: string
  suffix?: string
  url: string
  image?: string
  sort?: string
}

const menus: TrainModule[] = [
  {
    name: 'AI教培体系',
    desc: '果力智能为人工智能教师及用户所规划的线上云端教学纲领。内容涵盖了师资培训、课程体系、AI科创实验室、AI赛事所有内容的体系构建及案例分享。',
    level: 1,
    videos: [
      {
        name: '果力中小学人工智能教育体系构建及案例分享(一)',
        suffix: 'mp4',
        url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-system/果力中小学人工智能教育体系构建及案例分享.mp4',
        type: 'video',
        image:
          'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/其他图.png',
      },
      {
        name: '果力中小学人工智能教育体系构建及案例分享(二)',
        suffix: 'mp4',
        url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-system/果力中小学人工智能教育体系构建及案例分享(二).mp4',
        type: 'video',
        image:
          'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/其他图.png',
      },
    ],
    docs: [
      {
        name: '果力K12人工智能教育体系构建及案例分享',
        suffix: 'pptx',
        url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-system/果力K12人工智能教育体系构建及案例分享.pptx',
        type: 'document',
      },
      {
        name: '果力K12人工智能教育体系构建及案例分享测试题',
        suffix: 'docx',
        url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-system/%E6%9E%9C%E5%8A%9BK12%E4%BA%BA%E5%B7%A5%E6%99%BA%E8%83%BD%E6%95%99%E8%82%B2%E4%BD%93%E7%B3%BB%E6%9E%84%E5%BB%BA%E5%8F%8A%E6%A1%88%E4%BE%8B%E5%88%86%E4%BA%AB%E6%B5%8B%E8%AF%95%E9%A2%98.docx',
        type: 'document',
      },
    ],
  },
  {
    name: 'AI教具',
    desc: '涵盖了果力智能目前所有的产品说明。按顺序细致全面地讲解果力硬件，软件，套件及沙盘的全部内容，以视频或者附件的形式供用户学习或下载，最终以试题的方式验收老师的标准。',
    level: 1,
    nav: true,
    subs: [
      {
        name: '一、AI教育硬件平台',
        level: 2,
        id: 'hardware',
        subs: [
          {
            level: 3,
            name: 'Gomer AI机器人-果小聪',
            id: 'gomer',
            videos: [
              {
                sort: '宣传片',
                name: '果小聪宣传片',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪宣传片.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪.png',
              },
              {
                sort: '连接+操控',
                name: '连接+操控',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/%E8%BF%9E%E6%8E%A5%2B%E6%93%8D%E6%8E%A7.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪.png',
              },
              {
                sort: '连接+操控',
                name: '操控',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/操控.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪.png',
              },
              {
                sort: '连接+操控',
                name: 'AP与STA连接模式切换',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/AP与STA连接模式切换.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪.png',
              },
              {
                sort: 'AI课堂',
                name: '人脸识别',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/人脸识别.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪.png',
              },

              {
                name: '学习新图案',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/学习新图案.mp4',
                type: 'video',
                sort: 'AI课堂',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪.png',
              },
              {
                name: '机器学习',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/机器学习.mp4',
                type: 'video',
                sort: 'AI课堂',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪.png',
              },
              {
                name: '自定义图案结合编程运行',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/自定义图案结合编程运行.mp4',
                type: 'video',
                sort: 'AI课堂',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪.png',
              },

              {
                name: '果小聪-编程',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪-编程.mp4',
                type: 'video',
                sort: '编程',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪.png',
              },
              {
                name: '编程项目导入导出',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/编程项目导入导出.mp4',
                type: 'video',
                sort: '编程',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪.png',
              },

              {
                name: '认识你',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/认识你.mp4',
                type: 'video',
                sort: '本领',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪.png',
              },
              {
                name: '握手+自动抓取+叠辅具+单词猜猜看',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/%E6%8F%A1%E6%89%8B%2B%E8%87%AA%E5%8A%A8%E6%8A%93%E5%8F%96%2B%E5%8F%A0%E8%BE%85%E5%85%B7%2B%E5%8D%95%E8%AF%8D%E7%8C%9C%E7%8C%9C%E7%9C%8B.mp4',
                type: 'video',
                sort: '本领',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪.png',
              },

              {
                name: 'idle模式',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/idle模式.mp4',
                type: 'video',
                sort: '自主模式',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪.png',
              },
            ],
            docs: [
              {
                name: 'AI教具实操测试-果小聪',
                suffix: 'docx',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/AI教具实操测试-果小聪.docx',
                type: 'document',
              },
              {
                name: '果小聪与主题套件常见问题处理文档',
                suffix: 'pdf',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer/果小聪与主题套件常见问题处理文档.pdf',
                type: 'document',
              },
              {
                name: 'Gomer-果小聪',
                suffix: 'apk',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/app/Gomer.apk',
                type: 'apk',
              },
            ],
          },
          {
            level: 3,
            name: 'GomerX AI机器人-果小智',
            id: 'g3',
            videos: [
              {
                name: '果小智宣传视频',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-demonstration/果小智宣传视频.mp4',
                type: 'video',
                sort: '宣传',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智.png',
              },

              {
                name: '机械臂设计思路',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/机械臂设计思路.mp4',
                type: 'video',
                sort: '硬件结构',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智.png',
              },
              {
                name: '果小智-硬件结构',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智-硬件结构.mp4',
                type: 'video',
                sort: '硬件结构',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智.png',
              },
              {
                name: '结构+连接',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/%E7%BB%93%E6%9E%84%2B%E8%BF%9E%E6%8E%A5.mp4',
                type: 'video',
                sort: '硬件结构',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智.png',
              },
              {
                name: '麦克纳姆轮',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/麦克纳姆轮.mp4',
                type: 'video',
                sort: '硬件结构',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智.png',
              },
              {
                name: '操控',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/操控.mp4',
                type: 'video',
                sort: '操控',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智.png',
              },

              {
                name: '二维码',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/二维码.mp4',
                type: 'video',
                sort: '编程',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智.png',
              },
              {
                name: '机器学习',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/机器学习.mp4',
                type: 'video',
                sort: '编程',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智.png',
              },
              {
                name: '色块',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/色块.mp4',
                type: 'video',
                sort: '编程',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智.png',
              },
              {
                name: '编程模块功能讲解',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/编程模块功能讲解.mp4',
                type: 'video',
                sort: '编程',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智.png',
              },
              {
                name: '编程---巡线检测',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/编程---巡线检测.mp4',
                type: 'video',
                sort: '编程',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智.png',
              },
              {
                name: '编程---图案识别',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/编程--图案识别.mp4',
                type: 'video',
                sort: '编程',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智.png',
              },
              {
                name: '编程---二维码',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/编程---二维码.mp4',
                type: 'video',
                sort: '编程',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智.png',
              },

              {
                name: 'G3组装视频',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/G3组装视频v1.0.mp4',
                type: 'video',
                sort: '果小智组装视频',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智.png',
              },
            ],
            docs: [
              {
                name: 'AI教具实操测试-果小智',
                suffix: 'docx',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/AI教具实操测试-果小智.docx',
                type: 'document',
              },
              {
                name: '果小智使用注意事项',
                suffix: 'pdf',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/GomerX/果小智使用注意事项.pdf',
                type: 'document',
              },
              {
                name: 'GomerX-果小智',
                suffix: 'apk',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/app/GomerX.apk',
                type: 'apk',
              },
            ],
          },
          {
            level: 3,
            name: 'GomerX深度学习驾驶小车',
            id: 'depth',
            videos: [
              {
                name: '深度学习驾驶小车',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/depth/GomerX%E6%B7%B1%E5%BA%A6%E5%AD%A6%E4%B9%A0%E9%A9%BE%E9%A9%B6%E5%B0%8F%E8%BD%A6.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/depth/GomerX%E6%B7%B1%E5%BA%A6%E5%AD%A6%E4%B9%A0%E9%A9%BE%E9%A9%B6%E5%B0%8F%E8%BD%A6.png',
              },
            ],
          },
          {
            level: 3,
            name: '实物编程电子创客套装-果小灵',
            id: 'ling',
            videos: [
              {
                name: '果小灵',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/physical-programming/果小灵.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/physical-programming/果小灵.png',
              },
            ],
          },
          {
            level: 3,
            name: '智能编程积木电子套装-果小睿',
            id: 'rui',
            videos: [
              {
                name: '机器人大师',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/rui/%E6%9C%BA%E5%99%A8%E4%BA%BA%E5%A4%A7%E5%B8%88.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/rui/%E8%B5%84%E6%BA%90%E5%B9%B3%E5%8F%B0%E5%B0%81%E9%9D%A2-%E6%9E%9C%E5%B0%8F%E7%9D%BF.png',
              },
              {
                name: '创意百变',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/rui/%E6%9C%BA%E6%A2%B0%E5%A4%A7%E5%B8%88.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/rui/%E8%B5%84%E6%BA%90%E5%B9%B3%E5%8F%B0%E5%B0%81%E9%9D%A2-%E6%9E%9C%E5%B0%8F%E7%9D%BF.png',
              },
              {
                name: '机械大师',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/rui/%E5%88%9B%E6%84%8F%E7%99%BE%E5%8F%98.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/rui/%E8%B5%84%E6%BA%90%E5%B9%B3%E5%8F%B0%E5%B0%81%E9%9D%A2-%E6%9E%9C%E5%B0%8F%E7%9D%BF.png',
              },
            ],

            docs: [
              {
                name: '果小睿pc版安装指导',
                suffix: 'docx',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/rui/%E6%9E%9C%E5%B0%8F%E7%9D%BFpc%E7%89%88%E5%AE%89%E8%A3%85%E6%8C%87%E5%AF%BC.docx',
                type: 'document',
              },
              {
                name: '果小睿安装包',
                suffix: 'zip',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/rui/%E6%9E%9C%E5%B0%8F%E7%9D%BF%E5%AE%89%E8%A3%85%E5%8C%85.zip',
                type: 'file',
              },
            ],
          },
          {
            level: 3,
            name: 'AIOT人工智能课程套件-果小盒',
            id: 'he',
            videos: [
              {
                name: '果小盒',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/he/%E6%9E%9C%E5%B0%8F%E7%9B%92%E6%BC%94%E7%A4%BA%E8%A7%86%E9%A2%91.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/he/%E8%B5%84%E6%BA%90%E5%B9%B3%E5%8F%B0%E5%B0%81%E9%9D%A2-%E6%9E%9C%E5%B0%8F%E7%9B%92.png',
              },
            ],
            docs: [
              {
                name: '小果编程-教师版',
                suffix: 'exe',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/he/%E5%B0%8F%E6%9E%9C%E7%BC%96%E7%A8%8B-%E6%95%99%E5%B8%88%E7%89%88v1.0.0-32bit-setup.exe',
                type: 'exe',
              },
            ],
          },
          {
            name: '实物编程机器人-果小萌',
            id: 'meng',
            level: 3,

            videos: [
              {
                name: '果小萌',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer-baby/果小萌.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer-baby/果小萌.png',
              },
              {
                name: '果小萌视频合集',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer-baby/果小萌视频合集.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/Gomer-baby/果小萌.png',
              },
            ],
          },
          {
            level: 3,
            name: 'AI智能感知终端系列',
            id: 'face',
            videos: [
              {
                name: 'AI智能感知终端系列合集',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/face-perception/AI%E6%99%BA%E8%83%BD%E6%84%9F%E7%9F%A5%E7%BB%88%E7%AB%AF%E7%B3%BB%E5%88%97%E6%BC%94%E7%A4%BA%E8%A7%86%E9%A2%91.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/face-perception/AI%E6%99%BA%E8%83%BD%E6%84%9F%E7%9F%A5%E7%BB%88%E7%AB%AF%E7%B3%BB%E5%88%97%E6%BC%94%E7%A4%BA.png',
              },
            ],
            docs: [
              {
                name: '人脸感知终端说明',
                suffix: 'docx',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/face-perception/人脸感知终端说明.docx',
                type: 'document',
              },
              {
                name: '人脸特征说明书',
                suffix: 'pdf',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/face-perception/人脸特征说明书.pdf',
                type: 'document',
              },
              {
                name: '人体姿态感知终端',
                suffix: 'docx',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/body-perception/人体姿态感知终端.docx',
                type: 'document',
              },
              {
                name: '人体姿态说明书',
                suffix: 'pdf',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/body-perception/人体姿态说明书.pdf',
                type: 'document',
              },
            ],
          },
          {
            level: 3,
            name: '航天AI感知交互终端系统',
            id: 'aerospace',
            videos: [
              {
                name: '太空探索航天AI感知交互终端',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/aerospace/%E5%A4%AA%E7%A9%BA%E6%8E%A2%E7%B4%A2%E8%88%AA%E5%A4%A9AI%E6%84%9F%E7%9F%A5%E4%BA%A4%E4%BA%92%E7%BB%88%E7%AB%AF%E7%B3%BB%E7%BB%9F.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/aerospace/%E8%88%AA%E5%A4%A9AI%E6%84%9F%E7%9F%A5%E4%BA%A4%E4%BA%92%E7%BB%88%E7%AB%AF%E7%B3%BB%E7%BB%9F%E5%AE%A3%E4%BC%A0.png',
              },
              {
                name: '航天AI感知交互终端系统',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/aerospace/%E8%88%AA%E5%A4%A9AI%E6%84%9F%E7%9F%A5%E4%BA%A4%E4%BA%92%E7%BB%88%E7%AB%AF%E7%B3%BB%E7%BB%9F%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%91.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/aerospace/%E8%88%AA%E5%A4%A9AI%E6%84%9F%E7%9F%A5%E4%BA%A4%E4%BA%92%E7%BB%88%E7%AB%AF%E7%B3%BB%E7%BB%9F%E5%AE%A3%E4%BC%A0.png',
              },
            ],
          },
          {
            name: '康养配送服务机器人-果小康',
            id: 'kang',
            level: 3,
            videos: [
              {
                name: '果小康演示视频',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kang/%E5%BA%B7%E5%85%BB%E9%85%8D%E9%80%81%E6%9C%8D%E5%8A%A1%E6%9C%BA%E5%99%A8%E4%BA%BA-%E6%9E%9C%E5%B0%8F%E5%BA%B7%E6%BC%94%E7%A4%BA%E8%A7%86%E9%A2%9120220531-v1.3.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kang/%E5%BA%B7%E5%85%BB%E9%85%8D%E9%80%81%E6%9C%BA%E5%99%A8%E4%BA%BA-%E6%9E%9C%E5%B0%8F%E5%BA%B7.jpg',
              },
            ],
          },
        ],
      },
      {
        level: 2,
        name: '二、AI教育软件平台',
        id: 'software',
        subs: [
          {
            level: 3,
            name: '移动端AI教育平台',
            id: 'mobile',
            docs: [
              {
                name: '移动端果小聪项目编程',
                suffix: 'rar',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/education-platform-mobile/移动端果小聪项目编程.rar',
                type: 'document',
              },
              {
                name: '移动端果小智项目编程',
                suffix: 'rar',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/education-platform-mobile/移动端果小智项目编程.rar',
                type: 'document',
              },
            ],
          },
          {
            level: 3,
            name: 'PC端图形化编程-小果编程',
            id: 'xiaoguo',

            docs: [
              {
                name: '小果编程程序',
                suffix: 'rar',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/scratch/小果编程程序.rar',
                type: 'document',
              },
              {
                name: 'PC端项目编程',
                suffix: 'rar',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/scratch/pc端项目编程.rar',
                type: 'document',
              },
              {
                name: '小果编程APP',
                suffix: 'rar',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/scratch/GBlock.rar',
                type: 'document',
              },
            ],
          },
          {
            level: 3,
            name: 'Python SDK',
            id: 'python',
            docs: [
              {
                name: 'GomerX 开发者文档',
                url: 'http://sdk.glitech.com/',
                type: 'link',
              },
            ],
          },
          {
            level: 3,
            name: 'Future AI人工智能实训平台',
            id: 'future-ai',
            videos: [
              {
                name: 'Future AI人工智能实训平台',
                suffix: 'mp4',
                url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/futureAI/Future AI人工智能实训平台.mp4',
                type: 'video',
                image:
                  'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/futureAI/futureAI.png',
              },
            ],
          },
        ],
      },
      {
        level: 2,
        name: '三、AI教育主题套件',
        id: 'kit',
        videos: [
          {
            name: '无人驾驶',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/无人驾驶.mp4',
            type: 'video',
            sort: '套件安装',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/无人驾驶.png',
          },
          {
            name: '智慧医院',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/智慧医院.mp4',
            type: 'video',
            sort: '套件安装',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/智慧医院.png',
          },
          {
            name: '智慧社区',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/智慧社区.mp4',
            type: 'video',
            sort: '套件安装',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/智慧社区.png',
          },
          {
            name: '垃圾分类',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/垃圾分类.mp4',
            type: 'video',
            sort: '套件安装',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/垃圾分类.png',
          },
          {
            name: '地震救援',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/地震救援.mp4',
            type: 'video',
            sort: '套件安装',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/地震救援.png',
          },
          {
            name: '智慧物流',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/智慧物流.mp4',
            type: 'video',
            sort: '套件安装',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/智慧物流.png',
          },

          {
            name: '未来城市',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/未来城市.mp4',
            type: 'video',
            sort: '套件安装',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/未来城市.png',
          },
          // 套件演示

          {
            name: '无人驾驶',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-demonstration/无人驾驶.mp4',
            type: 'video',
            sort: '套件演示',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/无人驾驶.png',
          },
          {
            name: '智慧医院',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-demonstration/智慧医院.mp4',
            type: 'video',
            sort: '套件演示',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/智慧医院.png',
          },
          {
            name: '地震救援',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-demonstration/地震救援.mp4',
            type: 'video',
            sort: '套件演示',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/地震救援.png',
          },
          {
            name: '智慧社区',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-demonstration/智慧社区.mp4',
            type: 'video',
            sort: '套件演示',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/智慧社区.png',
          },
          {
            name: '智慧物流',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-demonstration/智慧物流.mp4',
            type: 'video',
            sort: '套件演示',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/智慧物流.png',
          },
          {
            name: '垃圾分类',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-demonstration/垃圾分类.mp4',
            type: 'video',
            sort: '套件演示',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/垃圾分类.png',
          },
          {
            name: '未来城市',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-demonstration/未来城市.mp4',
            type: 'video',
            sort: '套件演示',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/未来城市.png',
          },

          {
            name: '爱国主义',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-demonstration/爱国主义.mp4',
            type: 'video',
            sort: '套件演示',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/其他图.png',
          },
          {
            name: 'AI教育配套资源包',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-demonstration/AI教育资源拓展包.mp4',
            type: 'video',
            sort: '套件演示',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/AI教育配套资源包.png',
          },

          // 套件编程

          {
            name: '无人驾驶',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-program/无人驾驶.mp4',
            type: 'video',
            sort: '套件编程',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/无人驾驶.png',
          },

          {
            name: '智慧医院',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-program/智慧医院.mp4',
            type: 'video',
            sort: '套件编程',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/智慧医院.png',
          },

          {
            name: '智慧社区',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-program/智慧社区.mp4',
            type: 'video',
            sort: '套件编程',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/智慧社区.png',
          },
          {
            name: '智慧物流',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-program/智慧物流.mp4',
            type: 'video',
            sort: '套件编程',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/智慧物流.png',
          },

          {
            name: '地震救援',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-program/地震救援.mp4',
            type: 'video',
            sort: '套件编程',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/地震救援.png',
          },
          {
            name: '垃圾分类',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-program/垃圾分类.mp4',
            type: 'video',
            sort: '套件编程',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/垃圾分类.png',
          },

          // 套件使用及注意事项

          {
            name: '无人驾驶',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-notices/无人驾驶.mp4',
            type: 'video',
            sort: '套件使用及注意事项',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/无人驾驶.png',
          },
          {
            name: '智慧社区',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-notices/智慧社区.mp4',
            type: 'video',
            sort: '套件使用及注意事项',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/智慧社区.png',
          },
        ],
        docs: [
          {
            name: 'AI教育主题套件说明文档',
            suffix: 'docx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/AI教育主题套件说明文档.docx',
            type: 'document',
          },
          {
            name: 'AI教具实操测试-垃圾分类',
            suffix: 'docx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/AI教具实操测试-垃圾分类.docx',
            type: 'document',
          },
          {
            name: 'AI教具实操测试-智慧物流',
            suffix: 'docx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/AI教具实操测试-智慧物流.docx',
            type: 'document',
          },
          {
            name: 'AI教具实操测试-智慧社区',
            suffix: 'docx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/AI教具实操测试-智慧社区.docx',
            type: 'document',
          },
          {
            name: 'AI教具实操测试-地震救援',
            suffix: 'docx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/AI教具实操测试-地震救援.docx',
            type: 'document',
          },
          {
            name: 'AI教具实操测试-无人驾驶',
            suffix: 'docx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/AI教具实操测试-无人驾驶.docx',
            type: 'document',
          },
        ],
      },
    ],
  },
  {
    name: 'AI教研',
    level: 1,
    desc: '主要为教师提供人工智能教育的相关课程设计、教学设计和评测等教学研究，以及关于举办人工智能赛事的指南及相关案例分享。',
    subs: [
      {
        name: '一、人工智能前沿与应用',
        level: 2,

        videos: [
          {
            name: '人工智能前沿与应用',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/人工智能前沿与应用.mp4',
            type: 'video',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/其他图.png',
          },
        ],
        docs: [
          {
            name: '人工智能前沿与应用',
            suffix: 'pptx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/人工智能前沿与应用.pptx',
            type: 'document',
          },
        ],
      },
      {
        name: '二、人工智能知识体系及核心知识点',
        level: 2,
        videos: [
          {
            name: '人工智能课程相关核心基础原理',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/人工智能课程相关核心基础原理.mp4',
            type: 'video',
            image:
              'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-aids/kit-install/其他图.png',
          },
        ],
        docs: [
          {
            name: '人工智能核心知识基础',
            suffix: 'pptx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/人工智能核心知识基础.pptx',
            type: 'document',
          },
        ],
      },
      {
        name: '三、AI教学知识点测试题',
        level: 2,

        docs: [
          {
            name: '人工智能核心知识基础测试题',
            suffix: 'docx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/人工智能核心知识基础测试题.docx',
            type: 'document',
          },
        ],
      },
      {
        name: '四、人工智能课程试讲考核评价表',
        level: 2,
        docs: [
          {
            name: '果力人工智能课程试讲考核评价表',
            suffix: 'docx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/果力人工智能课程试讲考核评价表 .docx',
            type: 'document',
          },
        ],
      },
      {
        name: '五、中小学人工智能教育教研评价',
        level: 2,
        docs: [
          {
            name: '中小学人工智能教育教研评价',
            suffix: 'docx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/中小学人工智能教育教研评价.docx',
            type: 'document',
          },
        ],
      },
      {
        name: '六、中小学人工智能课程体系及教学设计思路介绍',
        level: 2,
        docs: [
          {
            name: '果力中小学AI教育课程体系及教学设计',
            suffix: 'pptx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/果力中小学AI教育课程体系及教学设计.pptx',
            type: 'document',
          },
          {
            name: '中小学人工智能课程体系及教学设计思路评测',
            suffix: 'doc',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/中小学人工智能课程体系及教学设计思路评测.doc',
            type: 'document',
          },
        ],
      },
      {
        name: '七、果力WYAI人工智能挑战赛赛项规则',
        level: 2,
        docs: [
          {
            name: '2020年淮北市中小学生机器人竞赛“果力WYAI人工智能挑战赛”报名表',
            suffix: 'docx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/2020年淮北市中小学生机器人竞赛“果力WYAI人工智能挑战赛”报名表.docx',
            type: 'document',
          },
          {
            name: '2020年淮北市中小学生机器人竞赛“果力WYAI人工智能挑战赛”赛项规则',
            suffix: 'docx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/2020年淮北市中小学生机器人竞赛“果力WYAI人工智能挑战赛”赛项规则.docx',
            type: 'document',
          },
          {
            name: '2021世界机器人大赛-青少年机器人设计大赛赛项申请表- 深圳果力智能科技有限公司',
            suffix: 'docx',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/2021世界机器人大赛-青少年机器人设计大赛赛项申请表- 深圳果力智能科技有限公司.docx',
            type: 'document',
          },
          {
            name: '附件1：第二十一届全国中小学电脑制作活动指南',
            suffix: 'pdf',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/附件1：第二十一届全国中小学电脑制作活动指南.pdf',
            type: 'document',
          },
          {
            name: '附件2：中央电化教育馆关于举办第二十一届电脑制作活动的通知',
            suffix: 'pdf',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/附件2：中央电化教育馆关于举办第二十一届电脑制作活动的通知.pdf',
            type: 'document',
          },
          {
            name: '果力智能历年举办赛事',
            suffix: 'pdf',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/果力智能历年举办赛事.pdf',
            type: 'document',
          },
          // {
          //   name: '教电〔2020〕16关于举办2020年淮北市中小学生机器人竞赛的通知',
          //   suffix: 'pdf',
          //   url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/teaching-research/教电〔2020〕16关于举办2020年淮北市中小学生机器人竞赛的通知.pdf',
          //   type: 'document',
          // },
        ],
      },
    ],
  },
  {
    name: 'AI示范课',
    level: 1,
    desc: 'AI示范课包括了北京朝阳区和广东东莞相关案例及果力人工智能示范课视频集锦。',
    subs: [
      {
        name: '一、示范课-北京朝阳区',
        level: 2,
        videos: [
          {
            name: '朝阳区第二实验小学远洋一方校区人工智能示范课',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/37296ae4f2653b463b9d4d3054f6eb99',
            type: 'video',
            image: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/北京示范课.png',
          },
        ],
      },
      {
        name: '二、示范课-广东省东莞市',
        level: 2,

        videos: [
          {
            name: '神奇的朋友示范课',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/356c97b3c8473484621cb89ec6875605',
            type: 'video',
            image: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/东莞示范课.png',
          },
        ],
      },
      {
        name: '三、示范课-海南省海口市',
        level: 2,
        videos: [
          {
            name: '海南海口市美兰区龙岐小学人工智能示范课(一)',
            suffix: 'mp4',
            url: 'https://gli-course.obs.myhuaweicloud.com/train/teaching-courses/海口示范课.mp4',
            type: 'video',
            image: 'https://gli-course.obs.myhuaweicloud.com/train/teaching-courses/海口示范课.png',
          },
          {
            name: '海南海口市美兰区龙岐小学人工智能示范课(二)',
            suffix: 'mp4',
            url: 'https://gli-course.obs.myhuaweicloud.com/train/teaching-courses/海口示范课2.mp4',
            type: 'video',
            image:
              'https://gli-course.obs.myhuaweicloud.com/train/teaching-courses/海口示范课2.png',
          },
        ],

        docs: [
          {
            name: '探索刷脸时代',
            suffix: 'pptx',
            url: 'https://gli-course.obs.myhuaweicloud.com/train/teaching-courses/探索刷脸时代.pptx',
            type: 'document',
          },
          {
            name: '神奇的朋友',
            suffix: 'pptx',
            url: 'https://gli-course.obs.myhuaweicloud.com/train/teaching-courses/神奇的朋友.pptx',
            type: 'document',
          },
        ],
      },
      {
        name: '四、视频集锦',
        level: 2,

        videos: [
          {
            name: '果力人工智能示范课集锦',
            suffix: 'mp4',
            url: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/0e4cee717810558fe4709394f057c6b1',
            type: 'video',
            image: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/train/示范课北京.png',
          },
        ],
      },
    ],
  },
]

export default menus
